import Box from '@mui/material/Box';
import { useState } from 'react';
import CheckSvg from '../../../global/SvgComponents/Check_svg';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../global/Button';

import './SortingV2.scss';

const SortingV2 = ({
  sortingOptions,
  handleSortingOption,
  sortingOptionSelected,
  handleClose,
}) => {
  const [sortingValue, setSortingValue] = useState(sortingOptionSelected);

  const handleSubmit = () => {
    handleSortingOption(sortingValue);
    handleClose();
  };

  const changeSortingValue = (option) => {
    setSortingValue(option);
  };

  return (
    <Box className="SortingV2__modal">
      <div className="SortingV2__modal--options">
        {sortingOptions.map((option) => (
          <div
            key={option.id}
            aria-hidden
            className="SortingV2__modal--options--option"
            onClick={() => changeSortingValue(option)}
          >
            {option.label}
            {sortingValue.id === option.id && <CheckSvg />}
          </div>
        ))}
      </div>
      <Button
        size={BUTTON_SIZE.LARGE}
        type={BUTTON_TYPE.QUATERNARY}
        onClick={handleSubmit}
        disabled={sortingValue.id === sortingOptionSelected.id}
      >
        Apply Sorting

      </Button>

    </Box>
  );
};

export default SortingV2;
